// @file: src/actions/api.js
import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL || "/api/v1",
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("vo_access_token");
  if (token) {
    config.headers.Authorization = `Bearer ${JSON.parse(token)}`;
  }
  return config;
});

export default api;
